<template>
  <div class="upload-image">
    <v-layout row>
      <v-flex :class="{xs6:item && item.value, xs12:!(item && item.value)}">
        <div class="dropbox">
          <input
            :multiple="false" 
            :disabled="uploading"
            accept="image/*" 
            type="file" 
            class="input-file"
            @change="filesChange($event.target.name, $event.target.files)" >
          <p v-if="!uploading">
            <span v-html="$t(`entity.${entity}.${field}.placeHolder`)"/>
          </p>
          <p v-else>
            {{ $t(`entity.${entity}.${field}.uploading`, {percentage: percentage}) }}
          </p>
        </div>
      </v-flex>      
      <v-flex 
        v-if="value"
        xs6>
        <img 
          :src="value.value"
          alt="image" >
      </v-flex>
    </v-layout>
    <div v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { storage } from '@/firebaseInit'
import uuidv4 from 'uuid/v4'
const debug = require('debug')('OD::BaseFormImage')

export default {
  name: 'BaseFormImage',
  props: {
    entity: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      percentage: 0,
      uploading: false,
      error: '',
      data: {
        path: '',
        value: '',
      },
    }
  },
  methods: {
    filesChange(name, files) {
      this.uploadImage(files[0])
    },
    uploadImage(file) {
      debug('uploadImage', this.field, file)
      if (file) {
        this.error = ''
        const metadata = { contentType: file.type }
        const storageRef = storage.ref()
        if (this.item) {
          this.data.path = `${this.entity}/${this.item.id}/${this.field}.${file.type.split('/')[1]}`
        } else {
          this.data.path = `${this.entity}/${this.field}/${uuidv4()}.${file.type.split('/')[1]}`
        }
        const uploadTask = storageRef.child(this.data.path).put(file, metadata)
        uploadTask.on(
          'state_changed', // storage.TaskEvent.STATE_CHANGED,
          snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.uploading = true
            this.percentage = progress.toFixed(2)
            debug('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case 'paused': // storage.TaskState.PAUSED: // or 'paused'
                debug('Upload is paused')
                break
              case 'running': // storage.TaskState.RUNNING: // or 'running'
                debug('Upload is running')
                break
            }
          },
          error => {
            this.uploading = false
            this.percentage = 0
            // https://firebase.google.com/docs/storage/web/handle-errors
            debug('error.code', error.code)
            this.error = error.code
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break
              case 'storage/canceled':
                // User canceled the upload
                break
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              debug('downloadURL', downloadURL)
              this.data.value = downloadURL
              this.uploading = false
              this.percentage = 0
              debug('update:value', this.data)
              this.$emit('update:value', this.data)
            })
          }
        )
      } else {
        debug('File empty')
      }
    },
  },
}
</script>

<style scoped>
.dropbox {
  outline: 2px dashed #adadad; /* the dash box */
  outline-offset: -10px;
  /* background: lightcyan; */
  color: #adadad;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  outline: 2px dashed #666; /* the dash box */
  color: #666;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 20px 0;
}

.upload-image img {
  max-width: 100%;
}
</style>
